import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CInput } from "@coreui/react";
import { copyRole, resetFilters, setSelected } from "../redux/rolesSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { ErrorList } from "../../../../components/ErrorList";

export const Copy = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const {
    currentUser: { organizations },
    selected: { selectedOrganizations, name, copyName },
    status,
    errors
  } = useSelector((state) => state.roles);

  const primaryButtonDisabled = !copyName.trim() || selectedOrganizations.length === 0;

  const primaryBtnHandler = () => {
    dispatch(copyRole());
  };

  useEffect(() => {
    if (status == "success") {
      close();
    }
  }, [status]);

  let close = () => {
    dispatch(resetFilters());
    onClose();
  };

  const onOrgsChange = (data) => {
    dispatch(setSelected({ selectedOrganizations: data }));
  };

  const onNameChange = (value) => {
    dispatch(setSelected({ copyName: value }));
  };

  return (
    <MainModal
      isOpen={isOpen}
      onClose={close}
      parentSelector=".roles"
      headerText={`Copy Role : ${name}`}
      headerCloseHandler={close}
      bodyClassName="main-popup-body"
      primaryButtonText="Save"
      primaryButtonDisabled={primaryButtonDisabled}
      primaryBtnHandler={() => primaryBtnHandler()}
      secondaryBtnText="Cancel"
      secondaryBtnHandler={close}
      width={700}
      height={420}
    >
      <div className="roles__copy-fields">
        <Dropdown
          height={275}
          haveOnSelectChange
          placeholder="Select Organizations"
          options={organizations}
          selectedFilters={selectedOrganizations}
          numberDisplayed={7}
          includeSelectAll
          onSelectChange={(data) => onOrgsChange(data)}
        />

        <CInput
          onChange={(e) => onNameChange(e.target.value)}
          className="text-input"
          type="text"
          placeholder="Enter a new role name"
          value={copyName}
        />
      </div>

      <ErrorList errors={errors} />
    </MainModal>
  );
};
